import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import joblogo from "../../../ReactKaamvalaWebsite/assets/icon/job-logo.svg";
const jobCards = [
  {
    id: 1,
    title: "Software Developer",
    company: "Advancing Packaging Private Limited",
    posted: "Posted 1 Day Ago",
    experience: "1-2 Years",
    salary: "1200k - 15000k",
    location: "Noida",
    workMode: "Full Time",
    hybrid: "Hybrid",
    shift: "Day",
    description:
      "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
  },
  {
    id: 2,
    title: "Software Developer",
    company: "Advancing Packaging Private Limited",
    posted: "Posted 1 Day Ago",
    experience: "1-2 Years",
    salary: "1200k - 15000k",
    location: "Noida",
    workMode: "Full Time",
    hybrid: "Hybrid",
    shift: "Day",
    description:
      "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
  },
  {
    id: 3,
    title: "Software Developer",
    company: "Advancing Packaging Private Limited",
    posted: "Posted 1 Day Ago",
    experience: "1-2 Years",
    salary: "1200k - 15000k",
    location: "Noida",
    workMode: "Full Time",
    hybrid: "Hybrid",
    shift: "Day",
    description:
      "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
  },
  {
    id: 4,
    title: "Software Developer",
    company: "Advancing Packaging Private Limited",
    posted: "Posted 1 Day Ago",
    experience: "1-2 Years",
    salary: "1200k - 15000k",
    location: "Noida",
    workMode: "Full Time",
    hybrid: "Hybrid",
    shift: "Day",
    description:
      "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
  },
  {
    id: 5,
    title: "Software Developer",
    company: "Advancing Packaging Private Limited",
    posted: "Posted 1 Day Ago",
    experience: "1-2 Years",
    salary: "1200k - 15000k",
    location: "Noida",
    workMode: "Full Time",
    hybrid: "Hybrid",
    shift: "Day",
    description:
      "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
  },
];
const Blog = () => {
  return (
    <>
      <h1>Hrllo</h1>
     <section id="Feature-section-2">
        <div className="container feature-section">
          <div className="row">
            <div
              className="col-lg-6 col-md-12
            "
            >
              <div className="feature-section-heading">
                <h2>Our Featured Jobs!</h2>
                <p>
                  Explore top job opportunities from leading companies. Find
                  positions that match your skills and take the next step in
                  your career!
                </p>
                <button>
                  <a href="">Explore Now</a>
                </button>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 swiper-container-column">
              <Swiper
                modules={[Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                navigation={{
                  nextEl: ".swiper-button-next-job-card",
                  prevEl: ".swiper-button-prev-job-card",
                }}
                breakpoints={{
                  768: {
                    slidesPerView: 2,
                    centeredSlides: true,
                  },
                }}
                className="slide-content job-card-content"
              >
                {jobCards.map((job) => (
                  <SwiperSlide key={job.id}>
                    <div
                      className="job-card"
                      style={{
                        padding: "0px",
                      }}
                    >
                      <div
                        className="card"
                        style={{
                          padding: "10px 10px",
                        }}
                      >
                        {/* <div> */}
                        <div className="feature-card-body-content">
                          <div className="feautre-card-body-img">
                            <img
                              src={joblogo}
                              height="52"
                              width="52"
                              alt="Web and app development"
                              title="Web and app development"
                            />
                          </div>
                          <div className="feautre-card-body-text">
                            <h6 className="card-title">{job.title}</h6>
                            <p className="card-subtitle mb-2 text-muted">
                              {job.company}
                            </p>
                          </div>
                          <div className="feautre-card-body-job-post">
                            <p>{job.posted}</p>
                          </div>
                        </div>
                        <div className="feature-card-body-salary my-2">
                          <p>{job.experience}</p>
                          <p>{job.salary}</p>
                          <p>{job.location}</p>
                        </div>
                        <div className="feature-card-body-workmode my-2">
                          <p>{job.workMode}</p>
                          <p>{job.hybrid}</p>
                          <p>{job.shift}</p>
                        </div>
                        <div className="feature-card-body-description">
                          <p>{job.description}</p>
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}

                <div className="swiper-button-prev swiper-button-prev-job-card">
                  {/* <FaChevronLeft className="icon" /> */}
                  <MdOutlineKeyboardArrowLeft />
                </div>
                <div className="swiper-button-next swiper-button-next-job-card">
                  {/* <FaChevronRight className="icon" /> */}
                  <MdOutlineKeyboardArrowRight />
                </div>
              </Swiper>
            </div>
          </div>
          <style jsx>{`
            .job-card {
              width: 280px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              box-shadow: 3px 3px 16px 0px rgba(0, 0, 0, 0.08);
              box-shadow: -3px -3px 16px 0px rgba(0, 0, 0, 0.08);
              background: rgba(255, 255, 255, 1);
              border-radius: 8px;
            }
            .swiper-slide {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .swiper-container-column {
              display: flex;
              overflow: hidden;
              justify-content: center;
              align-items: center;
            }

            .swiper-container {
              width: 750px !important;
              overflow: unset;
            }
            .card-body {
              border: unset !important;
              padding: 30px 20px;
            }

            .job-card-content .swiper-button-next-job-card {
              width: 48px;
              height: 48px;
              background: rgba(50, 132, 255, 1);
              border-radius: 50%;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .job-card-content .swiper-button-prev-job-card {
              width: 48px;
              height: 48px;
              background: rgba(50, 132, 255, 1);
              border-radius: 50%;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            @media screen and (max-width: 426px) {
              .job-card {
                width: 335px;
                margin-top: 25px;
              }
            }

            .swiper-button-next::after,
            .swiper-button-prev::after {
              display: none;
            }
          `}</style>
        </div>
      </section> 
    </>
  );
};
export default Blog;
